
//展会官网主域名
let baseUrl = "https://www.chinaminexpo.com";
let onlineUrl  = "https://e-show.chinaminexpo.com";

export default {
    'fontUrl':baseUrl,   //图片公共路径
    "baseUploadUrl":baseUrl+"/frontCommon/upload",
    "hzExhibitionLogin": onlineUrl+"/exhibitor/#/adminLogin",
    "hzAudienceLogin": onlineUrl+"/visitor/#/adminLogin",
    "hzExhibitionIndex": onlineUrl+"/exhibitor/#/backIndex/homeIndex",
    "hzAudienceIndex": onlineUrl+"/visitor/#/backIndex/homeIndex",
    
    "hzzhanhui":baseUrl+"/hz/f",
    "viewcz": baseUrl+"/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c",
    "viewcg": baseUrl+"/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33",
    "zwt":baseUrl+"/hz/f/hz/gzZwtIndex.html?categoryId=6f595480c4c74329bae5448ddf19cb8a",
    "zhrc":baseUrl+"/hz/f/list.html?categoryId=70b5d6c9d45245a09e51eff9b334e3c6",
    "messageUrl": onlineUrl+"/visitor/#/backIndex/messageDetail",
    "axiosBaseUrl": baseUrl+'/hz/',

    "visit":baseUrl+'/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33', //我要参观
    "ParticipateExhibition": baseUrl+'/hz/f/list.html?categoryId=8ff76b57a6674525a898d5ba4026352c', //我要参展
    
    "testDomain": 'http://vr.chinaminexpo.com/'
}
